import MenuDrawer from "../components/MenuDrawer/MenuDrawer";
import "./BusinessLayout.css";

function BusinessLayout({

    children,

    drawerOpen,

    setDrawerOpen,

}) {

    return (

        <div className="business-layout">

            <MenuDrawer

                isOpen={drawerOpen}

                onClose={() => setDrawerOpen(false)}

            />

            <main className="business-content">

                {children}

            </main>

        </div>

    );

}

export default BusinessLayout;